<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">Miniapps</div>
                </b-col>
            </b-row>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="text-muted">Coming Soon...</div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}
</style>

<script>
export default {
    
}
</script>